export default {
  title: "Protokolle",
  subtitle: "Interne PDF-Protokolle als Referenz für das Personal.",
  empty: "Keine Protokolle passen zu diesen Filtern.",
  emptyWritable: "Laden Sie das erste Protokoll-PDF hoch.",
  template: {
    download: "Vorlage herunterladen",
  },
  filters: {
    searchPlaceholder: "Nach Titel suchen",
    statusLabel: "Status",
    statusAll: "Alle Status",
    categoryLabel: "Kategorie",
    categoryPlaceholder: "z. B. Devices, Ops",
    tagLabel: "Tags",
    tagAll: "Alle Tags",
    tagCount: "{{count}} ausgewählt",
  },
  tags: {
    label: "Tags",
    placeholder: "Tags auswählen oder hinzufügen",
    searchPlaceholder: "Tags suchen…",
    create: "„{{name}}“ hinzufügen",
  },
  status: {
    ACTIVE: "Aktiv",
    SUSPENDED: "Ausgesetzt",
    OBSOLETE: "Veraltet",
  },
  actions: {
    view: "Ansehen",
    download: "Herunterladen",
    edit: "Bearbeiten",
    versions: "Versionen",
    addVersion: "Neue Version hinzufügen",
    markObsolete: "Als veraltet markieren",
    more: "Weitere Aktionen",
  },
  obsolete: {
    title: "Protokoll als veraltet markieren?",
    body: "„{{title}}“ verschwindet aus der Aktiv-Liste. Die Versionshistorie bleibt; neue Versionen können erst wieder veröffentlicht werden, wenn der Status wieder Aktiv ist.",
    confirm: "Als veraltet markieren",
    success: "Protokoll als veraltet markiert",
  },
  upload: {
    title: "Protokoll hochladen",
    titleLabel: "Titel",
    titlePlaceholder: "z. B. Evakuierungsplan",
    categoryLabel: "Kategorie",
    categoryPlaceholder: "z. B. Devices",
    statusLabel: "Status",
    fileLabel: "PDF-Datei",
    dropzoneTitle: "PDF hier ablegen oder klicken zum Auswählen",
    dropzoneDescription: "Nur PDF, max. 20 MB",
    submit: "Hochladen",
    success: "Protokoll hochgeladen",
  },
  edit: {
    title: "Protokoll bearbeiten",
    submit: "Speichern",
    success: "Protokoll aktualisiert",
  },
  versions: {
    title: "Versionen — {{title}}",
    publishTitle: "Neue Version hinzufügen — {{title}}",
    current: "Aktuell",
    loadError: "Versionen konnten nicht geladen werden",
    bumpLabel: "Versionstyp",
    bumpMinor: "Minor",
    bumpMinorDescription: "Kleine Updates oder Korrekturen.",
    bumpMajor: "Major",
    bumpMajorDescription: "Wesentliche Überarbeitung oder Richtlinienänderung.",
    changeSummaryLabel: "Was hat sich geändert",
    changeSummaryPlaceholder: "Optionale Notizen zu den Änderungen in dieser Version…",
    changeSummaryHint: "Optional",
    submit: "Version veröffentlichen",
    success: "Neue Version veröffentlicht",
    publishBlocked:
      "Reaktivieren Sie dieses Protokoll (Status Aktiv), bevor Sie eine neue Version veröffentlichen.",
  },
  errors: {
    titleRequired: "Titel eingeben",
    fileRequired: "PDF-Datei auswählen",
    fileTooLarge: "{{name}} ist zu groß. Maximale Größe ist {{max}}.",
    loadError: "Protokolle konnten nicht geladen werden",
  },
} as const;
